import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
interface Stat {
  label: string;
  value: string;
}
interface CompanyCardProps {
  name: string;
  description: string;
  stats: Stat[];
  variant?: 'blue' | 'pink';
  delay?: number;
}
export function CompanyCard({
  name,
  description,
  stats,
  variant = 'blue',
  delay = 0
}: CompanyCardProps) {
  const color = variant === 'blue' ? '#00f0ff' : '#ff006e';
  return <motion.div initial={{
    opacity: 0,
    y: 50
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} whileHover={{
    y: -10
  }} className="relative group" data-id="element-6">
      {/* Card Container */}
      <div className="relative h-full p-8 bg-[#0a0e27]/80 backdrop-blur-sm border border-opacity-50" style={{
      borderColor: `${color}40`
    }} data-id="element-7">
        {/* Animated Border Glow */}
        <motion.div animate={{
        boxShadow: [`0 0 5px ${color}20`, `0 0 20px ${color}40`, `0 0 5px ${color}20`]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="absolute inset-0 pointer-events-none" style={{
        border: `1px solid ${color}`
      }} data-id="element-8" />

        {/* Corner Brackets */}
        <div className="absolute -top-1 -left-1 w-6 h-6 border-t-2 border-l-2" style={{
        borderColor: color
      }} data-id="element-9" />
        <div className="absolute -top-1 -right-1 w-6 h-6 border-t-2 border-r-2" style={{
        borderColor: color
      }} data-id="element-10" />
        <div className="absolute -bottom-1 -left-1 w-6 h-6 border-b-2 border-l-2" style={{
        borderColor: color
      }} data-id="element-11" />
        <div className="absolute -bottom-1 -right-1 w-6 h-6 border-b-2 border-r-2" style={{
        borderColor: color
      }} data-id="element-12" />

        {/* Content */}
        <div className="relative z-10" data-id="element-13">
          <div className="flex justify-between items-start mb-6" data-id="element-14">
            <h3 className="text-2xl font-bold uppercase tracking-wider group-hover:text-white transition-colors" style={{
            color: color,
            textShadow: `0 0 10px ${color}60`
          }} data-id="element-15">
              {name}
            </h3>
            <ArrowUpRight className="w-6 h-6 opacity-0 group-hover:opacity-100 transition-opacity" style={{
            color
          }} data-id="element-16" />
          </div>

          <p className="text-gray-400 mb-8 font-light leading-relaxed" data-id="element-17">
            {description}
          </p>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 gap-4 pt-6 border-t border-gray-800" data-id="element-18">
            {stats.map((stat, index) => <div key={index} data-id="element-19">
                <div className="text-xs text-gray-500 uppercase tracking-widest mb-1" data-id="element-20">
                  {stat.label}
                </div>
                <div className="text-lg font-bold text-white font-mono" data-id="element-21">
                  {stat.value}
                </div>
              </div>)}
          </div>
        </div>

        {/* Scanline overlay specific to card */}
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-white/5 to-transparent opacity-0 group-hover:opacity-10 transition-opacity pointer-events-none h-full w-full" data-id="element-22" />
      </div>
    </motion.div>;
}